<button
  [type]="type"
  class="btn btn-{{ color }} text-nowrap"
  [disabled]="disabled"
  [ngbTooltip]="label | translate"
>
  <i [class]="icon"></i>
  <span class="ml-1 d-md-none" [translate]="label"></span>
</button>
